import useUserStorage from "../../../../hooks/storage/useUserStorage";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { LOCAL_STORAGE_KEYS, LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";
import { TLiteTradePositionSide } from "../../../LiteTrade/liteTradeConstants";
import { BEGINNERS_GUIDE_STEPS_COUNT } from "../beginnersGuideConstants";
import { logAppsflyerAction } from "../../../../app/appActions";
import { tutorialsSlice } from "../../../Tutorials/tutorialsReducer";
import { TUTORIAL_NAMES } from "../../../Tutorials/tutorialsConstants";
import { IBeginnersGuideContext } from "../context/beginnersGuideContext.t";

function useTutorialsBeginnersGuide() {
    const { getUserStorageItem, removeUserStorageItem, setUserStorageItem } = useUserStorage();
    const dispatch = useDispatch();

    const [activeStepIndex, setActiveStepIndex] = useState<number>(getUserStorageItem(LOCAL_STORAGE_KEYS.BEGINNERS_GUIDE_STEP_INDEX, 0));
    const [selectedOperationSide, setSelectedOperationSide] = useState<TLiteTradePositionSide | null>(getUserStorageItem(LOCAL_STORAGE_KEYS.BEGINNERS_GUIDE_OPERATION_SIDE, null));

    const stepForwardHandler = useCallback(() => {
        setActiveStepIndex(currentStepIndex => {
                const nextStepIndex = currentStepIndex + 1 >= BEGINNERS_GUIDE_STEPS_COUNT
                    ? currentStepIndex
                    : currentStepIndex + 1;
                dispatch(logAppsflyerAction({
                    name: LOG_AF_EVENT_NAMES.MINI_ONBOARDING_CHANGE_STEP,
                    payload: { prev: currentStepIndex, next: nextStepIndex },
                }));
                return nextStepIndex;
            },
        );
    }, [dispatch]);

    const stepBackHandler = useCallback(() => {
        setActiveStepIndex(currentStepIndex => {
            const nextStepIndex = currentStepIndex - 1;
            dispatch(logAppsflyerAction({
                name: LOG_AF_EVENT_NAMES.MINI_ONBOARDING_CHANGE_STEP,
                payload: { prev: currentStepIndex, next: nextStepIndex },
            }));
            return nextStepIndex;
        });
    }, [dispatch]);

    useEffect(() => {
        if (activeStepIndex + 1 >= BEGINNERS_GUIDE_STEPS_COUNT) {
            removeUserStorageItem(LOCAL_STORAGE_KEYS.BEGINNERS_GUIDE_STEP_INDEX);
            dispatch(tutorialsSlice.actions.updateTutorialSeenAction(TUTORIAL_NAMES.BEGINNERS_GUIDE));
        } else {
            setUserStorageItem(LOCAL_STORAGE_KEYS.BEGINNERS_GUIDE_STEP_INDEX, activeStepIndex);
        }
    }, [activeStepIndex, dispatch, removeUserStorageItem, setUserStorageItem]);

    const setSelectedOperationSideHandler = useCallback((side: TLiteTradePositionSide) => {
        setSelectedOperationSide(side);
        setUserStorageItem(LOCAL_STORAGE_KEYS.BEGINNERS_GUIDE_OPERATION_SIDE, side);
    }, [setUserStorageItem]);

    const beginnersGuideContextValue: IBeginnersGuideContext = useMemo(() => ({
        activeStepIndex,
        selectedOperationSide,
        setSelectedOperationSide: setSelectedOperationSideHandler,
        stepBack: stepBackHandler,
        stepForward: stepForwardHandler,
    }), [activeStepIndex, stepForwardHandler, stepBackHandler, selectedOperationSide, setSelectedOperationSideHandler]);

    return {
        beginnersGuideContextValue,
        activeStepIndex,
    }
}

export default useTutorialsBeginnersGuide;
